import { decrypted_key } from "../../../Utils"
import XORSHIFT128 from "../RNGLib"

export const to_hex = x => `0x${(x >>> 0).toString(16).toUpperCase()}`

export class BaseSeeds {
    constructor(unit_name, profileData, userData) {
        this.unit_name = unit_name
        this.profileData = profileData
        this.userData = userData
        this.setUpPull()
        this.setup_rng(userData)
    }

    setup_rng(userData) {
        this.init_rng(this.get_current_seed(userData))
    }

    init_rng(currentSeed) {
        this.rng = new XORSHIFT128(currentSeed[0], currentSeed[1], currentSeed[2], currentSeed[3])
    }

    format_state(state) {
        return (
            <>
                {state[0]} | {state[1]} | {state[2]} | {state[3]}
            </>
        )
    }

    get_initial_seed() {
        return new XORSHIFT128(`${decrypted_key()}_${this.unit_name}`)
    }

    estimate_start() {
        return 0
    }

    estimate_end() {
        return 0
    }

    seed_fits(current_state, entries) {
        return false
    }

    add_to_list(potential_seeds, current_state, entries) {
        potential_seeds.push(current_state)
    }

    advance_neutral(initial_seed) {
        initial_seed.get_u32()
    }

    find_seed(entries) {
        const initial_seed = this.get_initial_seed()
        const potential_seeds = []
        for (let i = 0; i < this.estimate_start(); i++) {
            this.advance_neutral(initial_seed)
        }
        for (let i = 0; i < this.estimate_end(); i += 1) {
            const current_state = initial_seed.get_clone()
            if (this.seed_fits(current_state, entries)) {
                this.add_to_list(potential_seeds, current_state, entries)
            }
            this.advance_neutral(initial_seed)
        }

        // Additional steps for people who cycled through all their banners in a previous patch
        if (potential_seeds.length === 0) {
            for (let i = 0; i < 50; i += 1) {
                const current_state = initial_seed.get_clone()
                if (this.seed_fits(current_state, entries)) {
                    this.add_to_list(potential_seeds, current_state, entries)
                    break
                }
                this.advance_neutral(initial_seed)
            }
        }
        return potential_seeds
    }

    calculateResultHandler(current_seed) {}

    get_current_seed(userData) {
        if (userData.CloudRandomSet === undefined) {
            const rng = this.get_initial_seed()
            return rng.get_state()
        }
        const inital_seed = userData.CloudRandomSet.Map[this.unit_name]

        return [to_hex(inital_seed.Context1), to_hex(inital_seed.Context2), to_hex(inital_seed.Context3), to_hex(inital_seed.Context4)]
    }

    set_current_seed(userData, newSeed) {
        const original = { ...userData }
        original.CloudRandomSet.Map[this.unit_name].Context1 = parseInt(newSeed[0].substring(2), 16)
        original.CloudRandomSet.Map[this.unit_name].Context2 = parseInt(newSeed[1].substring(2), 16)
        original.CloudRandomSet.Map[this.unit_name].Context3 = parseInt(newSeed[2].substring(2), 16)
        original.CloudRandomSet.Map[this.unit_name].Context4 = parseInt(newSeed[3].substring(2), 16)
        return original
    }

    set_current_seed_raw(userData, newSeed) {
        const original = { ...userData }
        original.CloudRandomSet.Map[this.unit_name].Context1 = parseInt(newSeed[0])
        original.CloudRandomSet.Map[this.unit_name].Context2 = parseInt(newSeed[1])
        original.CloudRandomSet.Map[this.unit_name].Context3 = parseInt(newSeed[2])
        original.CloudRandomSet.Map[this.unit_name].Context4 = parseInt(newSeed[3])
        return original
    }

    null_seed(userData) {
        return this.set_current_seed(userData, ["0x0", "0x0", "0x0", "0x0"])
    }

    update_seed(userData) {
        return this.set_current_seed(userData, this.rng.get_state())
    }
}
